"use client";
import clsx from "clsx";
import Image from "next/image";

import { useState, useRef, useEffect } from "react";
import s from "./styles.module.css";

import oleg from "@public/kit/Oleg.jpg";
import anton from "@public/kit/Anton.jpg";
import egor from "@public/kit/Egor.jpg";
import shaun from "@public/kit/Shaun.jpg";

export default function Faces() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [translateX, setTranslateX] = useState(0);

  const carouselItemsRef = useRef<Array<HTMLDivElement | null>>([]);

  const handleNext = () => {
    setActiveIndex((index) => Math.min(index + 1, 3));
  };
  const handlePrev = () => {
    setActiveIndex((index) => Math.max(index - 1, 0));
  };

  useEffect(() => {
    const activeRef = carouselItemsRef.current[activeIndex];
    if (activeRef) {
      setTranslateX(activeRef.offsetLeft);
    }
  }, [activeIndex]);

  return (
    <section className={s.personaliesSection}>
      <h2>Our founders</h2>
      <p className={s.p}>The people who started it all</p>
      <div className={s.navigationButtons}>
        <button onClick={handlePrev} className={s.navigationButton}></button>
        <button
          onClick={handleNext}
          className={`${s.navigationButton} ${s.right}`}
        ></button>
      </div>

      <div
        style={{ transform: `translateX(-${translateX}px)` }}
        className={s.carousel}
      >
        <div
          ref={(el: HTMLDivElement | null) => {
            carouselItemsRef.current[0] = el;
          }}
          onClick={() => setActiveIndex(0)}
          className={clsx(s.faceContainer, activeIndex === 0 && s.activePerson)}
        >
          <div className={s.faceWrapper}>
            <Image src={oleg} alt="Oleg Fomenko" className={s.img} />

            <div className={s.about}>
              <h3 className={s.h3}>OLEG FOMENKO</h3>
              <p className={s.p}>CEO, Sweat Economy</p>
            </div>
            <div className={s.faceOverlay}></div>
          </div>
          <article className={s.article}>
            A serial entrepreneur with a track record of scaling consumer
            products to global adoption. Oleg has spearheaded the transformation
            of the Sweatcoin concept into a full-fledged Web3 ecosystem. His
            leadership has been instrumental in building the Sweat Wallet user
            base to over 20 million, driving partner integrations, and guiding
            the operational scale-up of $SWEAT across new markets and platforms.
          </article>
        </div>
        <div
          className={clsx(s.faceContainer, activeIndex === 1 && s.activePerson)}
          ref={(el: HTMLDivElement | null) => {
            carouselItemsRef.current[1] = el;
          }}
          onClick={() => setActiveIndex(1)}
        >
          <div className={s.faceWrapper}>
            <Image
              src={shaun}
              loading="lazy"
              alt="Shaun Azam"
              className={s.img}
            />
            <div className={s.about}>
              <h3 className={s.h3}>SHAUN AZAM</h3>
              <p className={s.p}>CFO, Sweat Economy</p>
            </div>
            <div className={s.faceOverlay}></div>
          </div>
          <article className={s.article}>
            Shaun keeps a keen eye on the numbers and ensures our commercial
            operations run like clockwork. With experience running multiple
            startups and a background in banking and corporate finance, he’s
            well-positioned to lead our tokenomics and token strategy.
          </article>
        </div>
        <div
          className={clsx(s.faceContainer, activeIndex === 2 && s.activePerson)}
          onClick={() => setActiveIndex(2)}
          ref={(el: HTMLDivElement | null) => {
            carouselItemsRef.current[2] = el;
          }}
        >
          <div className={s.faceWrapper}>
            <Image src={egor} alt="Egor Khmelev" className={s.img} />
            <div className={s.about}>
              <h3 className={s.h3}>EGOR KHMELEV</h3>
              <p className={s.p}>CTO</p>
            </div>
            <div className={s.faceOverlay}></div>
          </div>
          <article className={s.article}>
            A product and technology visionary, Egor has been the architect of
            both Sweatcoin and Sweat Wallet’s technical foundations from the
            start. As the engineering lead behind Sweatcoin’s core movement
            validation technology and the CTO driving Sweat Wallet’s blockchain
            infrastructure, Egor ensures the platform remains fast, scalable,
            secure, and future-ready. His expertise bridges Web2 user experience
            with Web3 performance—bringing SWEAT’s mission to life through
            robust, scalable technology.
          </article>
        </div>
        <div
          className={clsx(s.faceContainer, activeIndex === 3 && s.activePerson)}
          ref={(el: HTMLDivElement | null) => {
            carouselItemsRef.current[3] = el;
          }}
          onClick={() => setActiveIndex(3)}
        >
          <div className={s.faceWrapper}>
            <Image src={anton} alt="Anton Derlyatka" className={s.img} />
            <div className={s.about}>
              <h3 className={s.h3}>ANTON DERLYATKA</h3>
              <p className={s.p}>Co-founder & CEO, Sweatcoin</p>
            </div>
            <div className={s.faceOverlay}></div>
          </div>
          <article className={s.article}>
            A seasoned operator with deep experience in consumer tech,
            scalability as well as global business leadership and strategy. As
            the co-founder and CEO of Sweatcoin, the app has grown to over 200
            million users under Anton’s leadership, laying the foundation for
            the creation of the Movement Economy and the birth of Sweat Wallet.
          </article>
        </div>
      </div>
    </section>
  );
}
